import { useEffect } from 'react';
import { Box, Container, Divider, Stack, Typography, useTheme } from '@mui/material';
import BrandLogo from './components/BrandLogo';
import DocsArticleBody from './docs/DocsArticleBody';
import TERMS_OF_SERVICE_HTML from './termsContent';

/**
 * Public Terms of Service page. The legal CONTENT comes verbatim from the
 * VerOps Terms of Service document; the STYLING is the website's — it reuses the
 * same {@link DocsArticleBody} renderer the marketing docs use, so headings,
 * lists, blockquotes and callouts match the rest of the site and follow the
 * light/dark theme. Opened in its own window from the footer / signup links.
 */
export default function TermsOfServicePage() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  useEffect(() => {
    const prev = document.title;
    document.title = 'VerOps — Terms of Service';
    return () => { document.title = prev; };
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', color: 'text.primary' }}>
      {/* Header — website chrome, not the source file's */}
      <Box sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
        <Container maxWidth="md" sx={{ py: 2 }}>
          <BrandLogo size={26} />
        </Container>
      </Box>

      <Container maxWidth="md" sx={{ py: { xs: 4, md: 6 } }}>
        <Typography variant="overline" sx={{ color: 'text.secondary', letterSpacing: '0.08em' }}>
          Legal
        </Typography>
        <Divider sx={{ mt: 1, mb: 3 }} />
        <DocsArticleBody html={TERMS_OF_SERVICE_HTML} isDark={isDark} />
      </Container>

      <Box sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <Container maxWidth="md" sx={{ py: 3 }}>
          <Stack direction="row" justifyContent="space-between" flexWrap="wrap" useFlexGap spacing={1}>
            <Typography sx={{ color: 'text.secondary', fontSize: 13 }}>
              © {new Date().getFullYear()} Attuned Technology LLC. All rights reserved.
              VerOps is a trading name of Attuned Technology LLC.
            </Typography>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}
